import * as types from "./rooms.actionTypes";
import { ErrorResponse } from "../../../interfaces/Response";
import { action, createAsyncAction } from "typesafe-actions";
import { createRoomAsyncRequest, createRoomAsyncResponse, getRoomAsyncRequest, getRoomAsyncResponse, selectRoomAsyncRequest, selectRoomAsyncResponse, updateRoomAsyncRequest, updateRoomAsyncResponse } from "./types";

export const resetState = () => action(types.RESET_STATE, {});

export const setError = (value: ErrorResponse) => action(types.SET_ERROR, { value });

export const getRoomAsync = createAsyncAction(
  types.GET_ROOM_REQUEST,
  types.GET_ROOM_SUCCESS,
  types.GET_ROOM_FAILURE
)<getRoomAsyncRequest, getRoomAsyncResponse, ErrorResponse>();

export const updateRoomAsync = createAsyncAction(
  types.UPDATE_ROOM_REQUEST,
  types.UPDATE_ROOM_SUCCESS,
  types.UPDATE_ROOM_FAILURE
)<updateRoomAsyncRequest, updateRoomAsyncResponse, ErrorResponse>();

export const createRoomAsync = createAsyncAction(
  types.CREATE_ROOM_REQUEST,
  types.CREATE_ROOM_SUCCESS,
  types.CREATE_ROOM_FAILURE
)<createRoomAsyncRequest, createRoomAsyncResponse, ErrorResponse>();

export const selectRoomAsync = createAsyncAction(
  types.SELECT_ROOM_REQUEST,
  types.SELECT_ROOM_SUCCESS,
  types.SELECT_ROOM_FAILURE
)<selectRoomAsyncRequest, selectRoomAsyncResponse, ErrorResponse>();